import React, { useEffect, useState } from "react";
import { QrCode, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
import { api, formatApiError, track } from "@/lib/api";

export default function QrPay({ bookingId, t, onPaid }) {
  const [qr, setQr] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!qr) { return undefined; }
    const iv = setInterval(async () => {
      try {
        const { data } = await api.get(`/pay-qr/${bookingId}/status`);
        if (data.paid) { clearInterval(iv); track("payment_success", { booking_id: bookingId, source: "qr" }); onPaid(); }
      } catch (e) { /* keep polling */ }
    }, 4000);
    return () => clearInterval(iv);
  }, [qr, bookingId, onPaid]);

  const open = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/pay-qr/${bookingId}`);
      if (data.paid) { onPaid(); return; }
      setQr(data);
      track("payment_start", { booking_id: bookingId, source: "qr" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "QR not available"); } finally { setLoading(false); }
  };

  if (!qr) {
    return (
      <button type="button" data-testid="qr-pay-open" onClick={open} disabled={loading} className="mt-3 w-full h-12 rounded-full border-2 border-[#121316] bg-white text-[#121316] font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60">
        {loading ? <Loader2 size={18} className="animate-spin" /> : <QrCode size={18} />} {t("qr_open")}
      </button>
    );
  }
  return (
    <div data-testid="qr-pay-box" className="mt-4 rounded-3xl border border-[#E5E0D8] bg-white p-5 text-center">
      <p className="font-display font-bold text-lg text-[#121316]">{t("qr_title")} ₹{qr.amount}</p>
      {qr.image_url
        ? <img data-testid="qr-pay-image" src={qr.image_url} alt="UPI QR" className="mx-auto mt-3 w-64 max-w-full rounded-xl" />
        : <div data-testid="qr-pay-image" className="mx-auto mt-3 w-fit p-3 bg-white rounded-xl border border-[#E5E0D8]"><QRCodeSVG value={qr.link_url} size={220} /></div>}
      <p className="mt-3 text-sm text-[#5A5D65]">{qr.image_url ? t("qr_hint") : t("qr_hint_link")}</p>
      {qr.link_url && <a data-testid="qr-pay-link" href={qr.link_url} target="_blank" rel="noreferrer" className="mt-1 inline-block text-sm font-bold text-[#E05624] underline">{qr.link_url}</a>}
      <p className="mt-2 text-sm font-bold text-[#1B8A4B] inline-flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> {t("qr_wait")}</p>
    </div>
  );
}
